import { axiosInstance2 } from "./axiosInstance";

const formApi = {
  submitLead: async (payload) => {
    return await axiosInstance2.post(
      "v1/leads/axesell-submit",
      payload
    );
  },
};

export default formApi;